import { Box, Card, Skeleton, Stack, Grid } from "@mui/material";

const LoadingPropertyItem = () => {
  return (
    <Card
      sx={{
        width: "100%",
        borderRadius: 3,
        boxShadow: 3,
        overflow: "hidden",
        bgcolor: "white",
      }}
    >
      {/* Top Image Area */}
      <Box sx={{ position: "relative", width: "100%", height: 220 }}>
        {/* Approximate image height */}
        <Skeleton variant="rectangular" width="100%" height="100%" />
        {/* 'Active' Tag Skeleton */}
        <Skeleton
          variant="rectangular"
          width={120}
          height={24}
          sx={{
            position: "absolute",
            top: 16,
            left: 16,
            borderRadius: 24,
          }}
        />
        <Skeleton
          variant="rectangular"
          width={62}
          height={24}
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            borderRadius: 24,
          }}
        />
        {/* Pagination Dots Skeleton */}
        <Stack
          direction="row"
          spacing={1}
          sx={{
            position: "absolute",
            bottom: 16,
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <Skeleton variant="circular" width={8} height={8} />
          <Skeleton variant="circular" width={8} height={8} />
          <Skeleton variant="circular" width={8} height={8} />
          {/* Add more if there are more dots */}
        </Stack>
      </Box>

      {/* Content Area */}
      <Box sx={{ p: 2 }}>
        {/* Price Skeleton */}
        <Skeleton variant="text" width="60%" height={32} sx={{ mb: 2 }} />

        {/* Share & Heart Icons Skeleton */}
        <Stack
          direction="row"
          spacing={1}
          justifyContent="flex-end"
          sx={{ mt: -5, mb: 1.5 }}
        >
          <Skeleton variant="circular" width={24} height={24} />
          {/* Approximate icon button size */}
          <Skeleton variant="circular" width={24} height={24} />
          {/* Approximate icon button size */}
        </Stack>

        {/* Property Details Row 1 (Beds, Showers, Sqft) Skeleton */}
        <Grid container spacing={1.5} sx={{ mb: 2 }}>
          <Grid item xs={4}>
            {/* Roughly divides into 3 columns */}
            <Stack direction="row" alignItems="center" spacing={1}>
              <Skeleton
                variant="rectangular"
                width={24}
                height={24}
                sx={{ borderRadius: 0.5 }}
              />
              {/* Icon placeholder */}
              <Skeleton variant="text" width="60%" height={20} />
              {/* Text for e.g., "3 beds" */}
            </Stack>
          </Grid>
          <Grid item xs={4}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Skeleton
                variant="rectangular"
                width={24}
                height={24}
                sx={{ borderRadius: 0.5 }}
              />
              <Skeleton variant="text" width="60%" height={20} />
            </Stack>
          </Grid>
          <Grid item xs={4}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Skeleton
                variant="rectangular"
                width={24}
                height={24}
                sx={{ borderRadius: 0.5 }}
              />
              <Skeleton variant="text" width="60%" height={20} />
            </Stack>
          </Grid>
        </Grid>

        {/* Location Skeleton */}
        <Stack
          direction="row"
          alignItems="flex-start"
          spacing={1}
          sx={{ mb: 1 }}
        >
          <Skeleton
            variant="rectangular"
            width={24}
            height={24}
            sx={{ borderRadius: 0.5, flexShrink: 0 }}
          />
          {/* Icon placeholder */}
          <Skeleton variant="text" width="85%" height={20} />
        </Stack>

        <Stack mb={1}>
          {/* Listing Agent/Broker/Source */}
          <Skeleton variant="text" width="100%" height={20} />
        </Stack>

        {/* CTA Skeleton */}
        <Stack spacing={1.5}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={40}
            sx={{ borderRadius: 8 }}
          />
          {/* Rounded button */}
          <Skeleton
            variant="rectangular"
            width="100%"
            height={40}
            sx={{ borderRadius: 8 }}
          />
          {/* Rounded button */}
        </Stack>
      </Box>
    </Card>
  );
};

export default LoadingPropertyItem;
